import React from 'react';
import { CheckIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function SolutionSection() {
  return <section id="how-it-works" className="bg-cool-gray py-24 md:py-32 overflow-hidden" data-id="element-132">
      <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-20 items-center" data-id="element-133">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="space-y-8" data-id="element-134">
          <h2 className="text-midnight-navy text-4xl md:text-5xl font-manrope font-bold leading-tight" data-id="element-135">
            Operational Clarity — Without the Complexity.
          </h2>
          <p className="text-midnight-navy/70 text-lg leading-relaxed" data-id="element-136">
            Not generic accounting software. All designed around how restaurants
            actually operate. We map your data to your real-world processes.
          </p>
          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-137">
            {['Track money in vs money out', 'Monitor food and labor costs', 'Understand operational spending', 'Improve inventory visibility', 'Make faster business decisions', 'Identify profit leaks early'].map((item, idx) => <motion.li key={item} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: idx * 0.1
          }} className="flex items-start gap-3 text-midnight-navy/80 font-medium" data-id="element-138">
                <div className="mt-1 bg-accent-red rounded-full p-0.5" data-id="element-139">
                  <CheckIcon className="w-3 h-3 text-white" data-id="element-140" />
                </div>
                {item}
              </motion.li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="bg-stark-white p-8 rounded-lg shadow-xl border border-gray-200" data-id="element-141">
          <div className="space-y-8" data-id="element-142">
            <div className="flex items-center justify-between border-b border-gray-100 pb-4" data-id="element-143">
              <h4 className="text-midnight-navy font-bold" data-id="element-144">
                Optimized Workflow
              </h4>
              <div className="flex gap-2" data-id="element-145">
                <div className="w-2 h-2 rounded-full bg-green-500" data-id="element-146" />
                <div className="w-2 h-2 rounded-full bg-gray-200" data-id="element-147" />
              </div>
            </div>
            <div className="h-48 flex items-end gap-2" data-id="element-148">
              {[40, 60, 45, 90, 65, 85, 70, 95, 80, 100].map((h, i) => <motion.div key={i} initial={{
              height: 0
            }} whileInView={{
              height: `${h}%`
            }} viewport={{
              once: true
            }} transition={{
              duration: 1,
              delay: i * 0.05,
              ease: 'circOut'
            }} className="flex-1 bg-midnight-navy/5 hover:bg-accent-red transition-colors rounded-t-sm cursor-pointer" data-id="element-149" />)}
            </div>
            <div className="grid grid-cols-3 gap-4" data-id="element-150">
              {[{
              label: 'Efficiency',
              value: '+24%',
              color: 'text-midnight-navy'
            }, {
              label: 'Waste',
              value: '-18%',
              color: 'text-accent-red'
            }, {
              label: 'Margin',
              value: '+12%',
              color: 'text-midnight-navy'
            }].map((stat, idx) => <motion.div key={stat.label} initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: 0.5 + idx * 0.1
            }} className="p-4 bg-cool-gray rounded" data-id="element-151">
                  <div className="text-xs text-midnight-navy/50 uppercase font-bold mb-1" data-id="element-152">
                    {stat.label}
                  </div>
                  <div className={`text-xl font-bold ${stat.color}`} data-id="element-153">
                    {stat.value}
                  </div>
                </motion.div>)}
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}